<template>
  <div class="container-fluid">
    <div class="row tick-row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h3>Please sign in to your account</h3>
                      <p>
                        To get support from a well-trained staff.
                      </p>
                    </div>

                    <form
                      id="contactForm"
                      name="contactForm"
                      method="post"
                      @submit.prevent="submit"
                      novalidate
                    >
                      <!-- <div class="form-group">
                                              <label for="exampleInputEmail1">Name*</label>
                                              <input type="text" class="form-control" id="" aria-describedby="" placeholder="Enter Name" required="">
                                              <small id="emailHelp" class="form-text text-muted">Your Name is Required.</small>
                                            </div> -->
                      <div class="form-group">
                        <label for="exampleInputEmail1">Email address*</label>
                        <input
                          type="email"
                          class="form-control"
                          aria-describedby="emailHelp"
                          placeholder="Enter email"
                          name="email"
                          id="email"
                          v-model="email"
                        />
                        <small
                          id="emailHelp"
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          style="color: red; font-size: 1em"
                          >Your Email is Required</small
                        >
                        <small
                          id="emailHelp"
                          class="form-text text-muted"
                          v-if="emailError"
                          style="color: red; font-size: 1em"
                          >Invalid Email address format</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Password*</label>
                        <input
                          type="password"
                          class="form-control"
                          id="exampleInputPassword1"
                          placeholder="Password"
                          v-model="password"
                        />
                        <small
                          id="emailHelp"
                          class="form-text text-muted"
                          v-if="passwordErrorRequiredError"
                          style="color: red; font-size: 1em"
                          >Your Password is Required</small
                        >
                      </div>
                      <!-- <div class="form-check">
                                              <input type="checkbox" class="form-check-input" id="exampleCheck1" required="">
                                              <label class="form-check-label" for="exampleCheck1">Check me for Login</label>
                                            </div> -->
                      <!-- <div class="reg-yet"><span>Not Register Yet? <a href="register">Register Now</a></span></div> -->
                      <div class="reg-yet"><span id="eWarning"></span></div>

                      <small
                        id="emailHelp"
                        class="form-text text-muted"
                        v-if="submitErrorDisplay"
                        style="
                          color: red;
                          font-size: 1em;
                          font-weight: bold;
                          background: #ffb6b6;
                          padding: 10px;
                          border-radius: 5px;
                          display: block;
                          text-align: center;
                        "
                        >{{ errorMessage }}</small
                      >
                      <!-- Invalid Email -->
                      <button type="submit" class="btn btn-primary check-btn">
                        Submit
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "support_login",
  data() {
    return {
      msg: "Clear Me Out - Support",
      email: "",
      password: "",
      errorMessage: "",
      passwordError: false,
      passwordErrorRequiredError: false,
      emailRequiredError: false,
      emailError: false,
      submitErrorDisplay: false,
    };
  },
  methods: {
    submit: function (e) {
      this.submitErrorDisplay = false;
      this.errorMessage = "";
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      this.emailError = false;
      this.emailRequiredError = false;
      this.ticketNumberRequiredError = false;
      this.passwordErrorRequiredError = false;

      console.log("this.email", this.email);

      if (this.email === "") {
        this.emailRequiredError = true;
        return;
      }

      if (!re.test(String(this.email).toLowerCase())) {
        this.emailError = true;
        return;
      }

      if (this.password === "") {
        this.passwordErrorRequiredError = true;
        return;
      }

      const $this = this;
      this.emailRequiredError = false;
      this.ticketNumberRequiredError = false;
      this.emailError = false;

      jQuery
        .post("https://staging.clearmeout.com/support-login.php", {
          email: this.email,
          password: this.password,
        })
        .done(function (data) {
          $this.email = "";
          $this.ticketNumber = "";
          if (data.status == 500) {
            $this.submitErrorDisplay = true;
            $this.errorMessage = data.status_message;
          }
        })
        .fail(function (xhr, status, error) {
          $this.submitErrorDisplay = true;
          $this.errorMessage = "User does not exists. Please try again.";
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/support_submit.vue